const GOOGLE_FONTS_BASE = 'https://fonts.googleapis.com/css2'
const LOADED_FONTS = new Set<string>()

const FONT_MAP: Record<string, string> = {
  'Inter': 'Inter:wght@400;500;600;700',
  'Geist': 'Geist:wght@400;500;600;700',
  'Roboto': 'Roboto:wght@400;500;700',
  'Poppins': 'Poppins:wght@400;500;600;700',
  'Nunito': 'Nunito:wght@400;500;600;700',
  'DM Sans': 'DM+Sans:wght@400;500;600;700',
  'Plus Jakarta Sans': 'Plus+Jakarta+Sans:wght@400;500;600;700',
}

export function loadFont(fontFamily: string): void {
  // Extract first font name from the CSS font-family string
  const fontName = fontFamily.split(',')[0].replace(/['"]/g, '').trim()

  if (LOADED_FONTS.has(fontName)) return
  if (!FONT_MAP[fontName]) return // system font, no need to load

  const link = document.createElement('link')
  link.rel = 'stylesheet'
  link.href = `${GOOGLE_FONTS_BASE}?family=${FONT_MAP[fontName]}&display=swap`
  document.head.appendChild(link)

  // Preconnect for faster loading
  if (!document.querySelector('link[href="https://fonts.gstatic.com"]')) {
    const preconnect = document.createElement('link')
    preconnect.rel = 'preconnect'
    preconnect.href = 'https://fonts.gstatic.com'
    preconnect.crossOrigin = 'anonymous'
    document.head.appendChild(preconnect)
  }

  LOADED_FONTS.add(fontName)
}
